import { Badge, Card, Col, Placeholder, Row } from "react-bootstrap";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";
import { ScanMulti } from "../common/models";

const formatStatusLabel = (status?: string) => {
    if (!status) {
        return "";
    }
    return status
        .split(/[\s_]+/)
        .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join(" ");
};

const getStatusClass = (status?: string) => {
    if (!status) return "";
    const normalized = status.toLowerCase();
    if (normalized === "likely" || normalized === "certain") {
        return "orange-bg";
    }
    if (normalized === "possible") {
        return "yellow-bg";
    }
    return "";
};

const getBadgeVariant = (status?: string) => {
    if (!status) return "secondary";
    const normalized = status.toLowerCase();
    if (normalized === "likely" || normalized === "certain") {
        return "warning";
    }
    if (normalized === "possible") {
        return "info";
    }
    if (normalized === "unlikely") {
        return "secondary";
    }
    return "secondary";
};

export const SectionSxRxButton = (props: {
    isLoading: boolean,
    idx: number,
    active?: number,
    setActive: (active: number) => void,
    data: any,
    title: string,
    color: string,
    scanMulti?: ScanMulti,
}) => {

    const unmetNeedsStatus = props.data?.unmet_needs;
    const statusLabel = formatStatusLabel(unmetNeedsStatus);
    const statusClass = getStatusClass(unmetNeedsStatus);
    const badgeVariant = getBadgeVariant(unmetNeedsStatus);

    return (
        <Card
            onClick={() => {props.setActive(props.idx)}}
            className={`notes-section ${statusClass} ${props.active === props.idx && "notes-section-active"}`}
        >
            <Card.Body>
                <Row>
                    <Col md={10}>
                        <strong>{props.title}</strong>
                    </Col>
                    <Col md={2} className="text-right">
                        {
                            statusLabel && (
                                <small><Badge bg={badgeVariant}>{statusLabel}</Badge></small>
                            )
                        }
                    </Col>
                </Row>
                {
                    props.isLoading ? (
                        <Placeholder animation="glow">
                            <Placeholder xs={4} />
                        </Placeholder>
                    ) : props.data && props.data.error ? (
                        <Row>
                            <Col>{props.data.error}</Col>
                        </Row>
                    ) : props.data && props.data.summary ? (
                        <Row>
                            <Col className="description-text">
                                <LLMDashboardMarkdownRenderer content={props.data.summary} scanMulti={props.scanMulti} />
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col className="description-text">
                                No Data
                            </Col>
                        </Row>
                    )
                }
            </Card.Body>
        </Card>
    );
};
